import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./registerServiceWorker";
import ArgonDashboard from "./plugins/argon-dashboard";
import BootstrapVue from "bootstrap-vue";
import VueNumberInput from "@chenfengyuan/vue-number-input";
import Axios from "axios";
import Vuelidate from "vuelidate";
import VueThailandAddress from "vue-thailand-address";
import "vue-thailand-address/dist/vue-thailand-address.css";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import BlockUI from "vue-blockui";
import VueHtmlToPaper from "vue-html-to-paper";
import moment from "moment";
import numFormat from "vue-filter-number-format";
import VueExcelXlsx from "vue-excel-xlsx";
import JsonExcel from "vue-json-excel";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import "@trevoreyre/autocomplete-vue/dist/style.css";
import userRoles from "./helpers/userRoles";
import globalDatetime from "./constants/globalDatetime";
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
// import draggable from 'vuedraggable'
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import { Icon } from "@iconify/vue2";

const options = {
  name: "_new",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://unpkg.com/kidlat-css/css/kidlat.css",
  ],
};

// Vue.use(VueGoogleMaps, {
//   load: {
//     key: process.env.VUE_APP_GOOGLE,
//     libraries: "places", // This is required if you use the Autocomplete plugin
//     region: "TH",
//     language: "th",
//     v: "3.40",
//   },
// });

Vue.prototype.$USER_LOGIN = userRoles;
Vue.prototype.$NOW = globalDatetime;
Vue.prototype.moment = moment;
Vue.prototype.$API_URL = process.env.VUE_APP_API;
Vue.prototype.$http = Axios;
// Vue.prototype.$firebase = firebase;
Vue.prototype.$THEME = false;
Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VueHtmlToPaper, options);
Vue.use(ArgonDashboard);
Vue.use(VueNumberInput);
Vue.use(Vuelidate);
Vue.use(VueThailandAddress);
Vue.use(BlockUI);
Vue.use(VueExcelXlsx);
Vue.use(Autocomplete);
Vue.filter("numFormat", numFormat);

Vue.component("Icon", Icon);
Vue.component("v-select", vSelect);
Vue.component("Datepicker", Datepicker);
Vue.component("downloadExcel", JsonExcel);
Vue.component("date-range-picker", DateRangePicker);

Vue.component("vue-timepicker", VueTimepicker);

Vue.mixin({
  mounted() {
    this.autoload();
  },
  data() {
    return {
      WALLET: {
        status: false,
        error: null,
        available_balance: 0,
        peg_balance: 0,
        balance: 0,
      },
    };
  },
  methods: {
    autoload() {
      try {
        this.WALLET = JSON.parse(localStorage.getItem("wallet"));
      } catch (err) {
        console.log(`mainjs_mixin:: ${err}`);
      }
    },
  },
  computed: {
    $WALLET: {
      get: function () {
        return this.WALLET;
      },
      set: function (newWallet) {
        this.WALLET = newWallet;
      },
    },
    $TOKEN() {
      return localStorage.getItem("access_token");
    },
  },
});

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
